import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export default function PopularEntermaintIndex() {
    const place = useSelector(state => state.place);

    const musicList = [
        { img: "entertainment3.png", title: "Performing Arts", category: "Performing" },
        { img: "entertainment4.png", title: "Winery/Brewery", category: "Brewery" },
        { img: "comedy.png", title: "Comedy", category: "Comedy" },
        { img: "entertainment2.png", title: "Family", category: "Family" }
    ];

    return (
        <section className="section-equal-padding owl-nav-left">
            <div className="container-fluid">
                <div
                            className="section-top-heading mb-3 mb-md-5"
                            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
                        >
                            <h2 className="mb-2 text-black">Popular Entertainment</h2>
                            <p>Tons of exciting things for entertainment</p>
                        </div>
                <Swiper
                    modules={[Navigation, Autoplay]}
                    navigation
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    spaceBetween={20}
                    slidesPerView={3}
                    breakpoints={{
                        0: { slidesPerView: 1 },
                        576: { slidesPerView: 2 },
                        992: { slidesPerView: 3 },
                        1400: { slidesPerView: 4 },
                    }}
                    className="Owl3card pb-70"
                >
                    {musicList.map((item, index) => {
                        const safePlace =
                            place && place.toLowerCase() !== item.category.toLowerCase()
                                ? place
                                : "";

                        const url = safePlace
                            ? `/things-to-do/${item.category}/${encodeURIComponent(safePlace)}`
                            : `/things-to-do/${item.category}`;

                        return (
                            <SwiperSlide key={index}>
                                <div class="entertainment-box" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                                        <figure>
                                            <img src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/${item?.img}`} className="img-fluid" alt="popular-enterainment" />
                                        </figure>
                                        <div class="exp-description mt-3">
                                            <h3>{item?.title}</h3>
                                            <Link to={url}>
                                                Explore More <i className="fa-solid fa-arrow-right"></i>
                                            </Link>
                                        </div>
                                    </div>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </div>
        </section>
    );
}
